import * as React from 'react';
import style from './Registrierungen.less';
import * as classNames from 'classnames';
import { lazyInject } from '../../../services/inversify';
import { IDs } from '../../../helpers/IDs';
import DialogWrapper2 from '../../../core/dialog/dialog_wrapper_v2';
import { WSimpleTupelList } from '../../../core/lists/WSimpleTupelList';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { DataService } from '../../../services/data_service';

interface RegistrierungenDialogProps extends React.ClassAttributes<any> {
    data: any;
    row: any;
    onReload(entity: string): void;
    onClose(): void;
}

interface RegistrierungenDialogState {
    unternehmenSelected: number;
    showUnternehmenAddDialog: boolean;
    kontaktSelected: number;
    showKontaktAddDialog: boolean;
    // freigabeSelected: number;
}

export class RegistrierungenDialog extends React.Component<RegistrierungenDialogProps, RegistrierungenDialogState> {

    constructor(props: any) {
        super(props);
        this.state = {
            unternehmenSelected: 0,
            showUnternehmenAddDialog: false,
            kontaktSelected: 0,
            showKontaktAddDialog: false,
            // freigabeSelected: undefined
        };
        this.save = this.save.bind(this);
    }
    private tupelUnternehmen: Array<any> = [];
    private tupelKontakt: Array<any> = [];

    @lazyInject(DataService) private dataService: DataService;

    componentWillMount() {
        this.buildTupel();
    }
    componentDidMount() {
        const row = this.props.row;
        const kontakte: Array<any> = this.props.data[IDs.ENT_KONTAKTE];
        const kon_found = kontakte.find((kon: any) => row.kontakt_orig ?
            kon.tid === row.kontakt_orig : kon.tid === row.kontakt);
        this.setState({
            // freigabeSelected: row.status,
            kontaktSelected: row.kontakt_orig ? row.kontakt_orig : row.kontakt,
            unternehmenSelected: kon_found ? kon_found.unternehmen_orig : 0
        });
    }
    render() {
        return (
            <div>
                <DialogWrapper2
                    onAfterClose={this.props.onClose}
                >
                    <div className={style.colContainer} >
                        {this.renderUnternehmen()}
                        {this.renderKontakt()}
                        {/* {this.renderFreigabe()} */}
                        {this.state.showUnternehmenAddDialog && this.renderUnternehmenAddDialog()}
                        {this.state.showKontaktAddDialog && this.renderKontaktAddDialog()}
                        <div
                            style={{ textAlign: 'center', padding: '15px' }}
                        >
                            <button
                                onClick={this.save}
                                style={{ padding: '5px', borderRadius: '5px', backgroundColor: '#CCF' }}
                            // disabled={!(this.state.kontaktSelected > 0)}
                            >
                                Kontaktverknüpfung speichern
                            </button>
                        </div>
                    </div>

                </DialogWrapper2>
            </div>
        );
    }
    save() {
        const data = {
            tid: this.props.row.tid,
            kontakt: this.state.kontaktSelected
        };
        this.dataService.saveData(IDs.ENT_REGISTRIERUNG, data, undefined, false,
            (suc: boolean) => {
                alert('Registrierung wurde gespeichert!');
                this.props.onReload(IDs.ENT_REGISTRIERUNG);
                this.props.onClose();
            }, IDs.MOD_ETOOL_ADMIN);
    }
    renderUnternehmen() {
        return <div className={style.colContainer} >
            <div
                className={style.titel}
            >
                Unternehmen
            </div>
            <div className={style.rowContainer} >
                <div
                    style={{ minWidth: '450px', margin: '4px' }}
                >
                    <div
                        className={style.titel_sub}
                    >Unternehmensangaben aus Registrierung</div>
                    <WSimpleTupelList
                        data={this.tupelUnternehmen}
                        widthName={200}
                        widthValue={200}
                    />
                </div>
                <div
                    style={{ minWidth: '400px', margin: '4px' }}
                >
                    <div
                        className={style.titel_sub}
                    >Auswahl Unternehmen</div>
                    <div>
                        {this.renderUnternehmenSelect()}
                    </div>
                </div>
            </div>
        </div>;
    }
    renderKontakt() {
        return <div className={style.colContainer} >
            <div
                className={style.titel}
            >
                Kontaktdaten
            </div>
            <div className={style.rowContainer} >
                <div
                    style={{ minWidth: '450px', margin: '4px' }}
                >
                    <div
                        className={style.titel_sub}
                    >Kontaktdaten aus Registrierung
                    </div>
                    <WSimpleTupelList
                        data={this.tupelKontakt}
                        widthName={200}
                        widthValue={200}
                    />
                </div>
                <div
                    style={{ minWidth: '400px', margin: '4px' }}
                >
                    <div
                        className={style.titel_sub}
                    >Auswahl Kontakt</div>
                    <div>
                        {this.renderKontaktSelect()}
                    </div>
                </div>
            </div>
        </div>;
    }
    // renderFreigabe() {
    //     return (
    //         <div className={style.colContainer} >
    //             <div
    //                 className={style.titel}
    //             >
    //                 Freigabe
    //             </div>
    //             <div className={style.rowContainer} >
    //                 <div
    //                     style={{ minWidth: '450px', margin: '4px' }}
    //                 >
    //                     Freigabe-Status der Registrierung
    //                 </div>
    //                 <div
    //                     style={{ minWidth: '400px', margin: '4px' }}
    //                 >
    //                     <div>
    //                         {this.renderFreigabeSelect()}
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }
    renderUnternehmenSelect() {
        const unternehmen: Array<any> = this.props.data[IDs.ENT_UNTERNEHMEN];
        return <div>
            <div>
                <select
                    value={this.state.unternehmenSelected}
                    onChange={(evt: any) => this.setState({
                        unternehmenSelected: evt.target.value,
                        kontaktSelected: 0
                    })}
                    style={{ fontSize: '12px' }}
                >
                    <option value={0} key={'un_sel_' + 'leer'}></option>
                    {unternehmen && unternehmen.map((unt: any, idx: number) =>
                        <option
                            key={'un_sel_' + idx}
                            value={unt.tid}
                            style={{ fontSize: '12px' }}
                        >{unt.bezeichnung + ' (' + (unt.strasse || '-') + ', ' + (unt.ort || '-') + ')'}</option>
                    )}
                </select>
            </div>
            <div>
                <WActionButton
                    label='Unternehmen hinzufügen'
                    action='add'
                    key='action_unternehmen_add'
                    onAction={() => this.setState({ showUnternehmenAddDialog: true })}
                />
            </div>
        </div>;
    }
    renderKontaktSelect() {
        if (!this.state.unternehmenSelected || this.state.unternehmenSelected <= 0) {
            return <div style={{ fontSize: '10px', fontStyle: 'italic' }}>
                Bitte wählen Sie zunächst ein Unternehmen aus. <br />
                oder legen Sie ein Unternehmen an, falls es noch nicht existiert.</div>;
        }
        const kontakte: Array<any> = this.props.data[IDs.ENT_KONTAKTE];
        return <div>
            <div>
                <select
                    value={this.state.kontaktSelected}
                    onChange={(evt: any) => this.setState({ kontaktSelected: evt.target.value })}
                    style={{ fontSize: '12px' }}
                >
                    <option value={0} key={'kon_sel_' + 'leer'}></option>

                    {kontakte &&
                        kontakte.filter((kon: any) => kon.unternehmen_orig + '' === this.state.unternehmenSelected + '')
                            .map((kon: any, idx: number) =>
                                <option
                                    key={'kon_sel_' + idx}
                                    value={kon.tid}
                                    style={{ fontSize: '12px' }}
                                >{kon.vorname + ' ' + kon.name + ' (' + kon.e_mail || '' + ')'}</option>
                            )}
                </select>
            </div>
            <div>
                <WActionButton
                    label='Kontakt hinzufügen'
                    action='add'
                    key='action_kontakt_add'
                    onAction={() => this.setState({ showKontaktAddDialog: true })}
                />
            </div>
        </div>;
    }
    // renderFreigabeSelect() {
    //     return <div>
    //         <div>
    //             <select
    //                 value={this.state.freigabeSelected}
    //                 onChange={(evt: any) => {
    //                     const val = evt.target.value;
    //                     const row = this.props.row;
    //                     if (val === '2') {
    //                         if (row.mail_confirmed !== 1 && !confirm('Die E-Mail-Adresse wurde noch nicht bestätigt, wollen Sie trotzdem freigeben?')) {
    //                             return;
    //                         }
    //                     }
    //                     this.setState({ freigabeSelected: val });
    //                 }}
    //                 style={{ fontSize: '12px' }}
    //             >
    //                 <option value={0} key={'un_sel_' + 'leer'}></option>
    //                 <option value={1} key={'un_sel_' + '1'}>unverarbeitet</option>
    //                 <option value={2} key={'un_sel_' + '2'}>freigegeben</option>
    //                 <option value={3} key={'un_sel_' + '3'}>gesperrt</option>

    //             </select>
    //         </div>
    //     </div>;
    // }
    renderUnternehmenAddDialog() {
        const row = this.props.row;
        return <WFormsTableWrapper
            key={'add_unternehmen_form'}
            entity={IDs.ENT_UNTERNEHMEN}
            module={IDs.MOD_ETOOL_ADMIN}
            customClass={'Custom-ETA'}
            formLayout={'flowV2'}
            directEditFormularOf={{ tid: 0 }}
            formPreset={{
                bezeichnung: row.unternehmen,
                strasse: row.strasse + ' ' + row.hausnummer,
                ort: row.ort,
                plz: row.plz
            }}
            onAfterAction={(action: string) => {
                if (action === 'closeForm') {
                    this.setState({ showUnternehmenAddDialog: false });
                }
            }}
            onSaveDone={(entity: string, values: any, bundle: any, saveTid: number) => {
                this.setState({
                    showUnternehmenAddDialog: false,
                    unternehmenSelected: saveTid,
                    kontaktSelected: 0
                }, () => this.props.onReload(IDs.ENT_UNTERNEHMEN));
            }}
        />;
    }
    renderKontaktAddDialog() {
        const row = this.props.row;
        return <WFormsTableWrapper
            key={'add_kontakt_form'}
            entity={IDs.ENT_KONTAKTE}
            module={IDs.MOD_ETOOL_ADMIN}
            customClass={'Custom-ETA'}
            formLayout={'flowV2'}
            hiddenFormFields={['user']}
            directEditFormularOf={{ tid: 0 }}
            formPreset={{
                name: row.name,
                vorname: row.vorname,
                e_mail: row.mail,
                telefon: row.plz,
                telefonnummer: row.telefon,
                unternehmen: this.state.unternehmenSelected
            }}
            onAfterAction={(action: string) => {
                if (action === 'closeForm') {
                    this.setState({ showKontaktAddDialog: false });
                }
            }}
            onSaveDone={(entity: string, values: any, bundle: any, saveTid: number) => {
                this.setState({ showKontaktAddDialog: false, kontaktSelected: saveTid },
                    () => this.props.onReload(IDs.ENT_KONTAKTE));
            }}
        />;
    }
    buildTupel() {
        const row = this.props.row;
        this.tupelUnternehmen.push({ name: 'Unternehmen', value: row.unternehmen });
        this.tupelUnternehmen.push({ name: 'Strasse', value: row.strasse });
        this.tupelUnternehmen.push({ name: 'Hausnummer', value: row.hausnummer });
        this.tupelUnternehmen.push({ name: 'PLZ', value: row.plz });
        this.tupelUnternehmen.push({ name: 'Ort', value: row.ort });
        this.tupelKontakt.push({ name: 'Name', value: row.name });
        this.tupelKontakt.push({ name: 'Vorname', value: row.vorname });
        this.tupelKontakt.push({ name: 'Telefon', value: row.telefon });
        this.tupelKontakt.push({ name: 'E-Mail', value: row.mail });
        this.tupelKontakt.push({
            name: 'E-Mail bestätigt',
            value: row.mail_confirmed === 1 ? 'Ja' : <span style={{ color: 'red' }}>Nein</span>
        });
        this.tupelKontakt.push({
            name: 'Freigegeben',
            value: row.active === 1 ? 'Ja' : <span style={{ color: 'red' }}>Nein</span>
        });
    }
}
